/**
 *
 * @param {LatchKeyProduct} [product]
 * @returns {string[]}
 */
export default function LatchkeyNamesParser(product) {
  return product?.detail?.orderedMasterGroupList || [];
}
